<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div
    class="h-screen flex w-full vx-row no-gutter justify-center"
    style="background-color: #ffffff"
    id="page-login"
  >
    <vs-col vs-type="flex" vs-w="6" style="border-radius: 2.2rem">
      <vs-row vs-type="flex" vs-justify="center">
        <vs-row
          class="text-mood"
          vs-w="12"
          vs-align="center"
          vs-justify="center"
        >
          <img :src="logo" class="responsive logo py-2 px-2" />
        </vs-row>
        <vs-row vs-type="flex" vs-w="6" vs-justify="center">
          <login-jwt :isBis="false" :isDocument="false"></login-jwt>
        </vs-row>
      </vs-row>
      <div class="top-left-button d-none d-md-block">
      <vs-button
        style="min-width: 12rem; display: flex; align-items: center;"
        class="mt-2"
        href="/pages/document-login"
      >
        <div style="display: flex; align-items: center;">
          <i class="material-icons mr-2">description</i>
          <span>Dökümanlar</span>
        </div>
      </vs-button>
    </div>
      <div class="top-right-button d-none d-md-block">
        <div>
  <vs-button style="min-width: 22rem; display: flex; align-items: center;" class="mt-2" href="/pages/bis-login">
    <div style="display: flex;">
      <img style="object-fit: contain" width="50px" height="30px" src="/img/iletisim.jpg">
      <span style="flex-grow: 1; text-align: center; margin-left: 1rem;">Brew Mood İletişim Sistemi</span>
    </div>
  </vs-button>
</div>
<div></div>

  <div>
  <vs-button style="min-width: 22rem; display: flex; align-items: center;" class="mt-2" onClick="javascript:window.open('https://app.radiorder.com/', '_blank');">
    <div style="display: flex;">
      <img style="object-fit: contain" width="50px" height="30px" src="/img/radio-order.png">
      <span style="flex-grow: 1; text-align: center; margin-left: 1rem;">RadiOrder</span>
    </div>


  </vs-button>
</div>

<div>
  <vs-button style="min-width: 22rem; display: flex; align-items: center;" class="mt-2" onClick="javascript:window.open('https://siparis.holoco.com.tr', '_blank');">
    <div style="display: flex;">
      <img style="object-fit: contain" width="50px" height="30px" src="/img/holoco-logo.jpg">
      <span style="flex-grow: 1; text-align: center; margin-left: 1rem;">Holoco</span>
    </div>
  </vs-button>
</div>
<div>
  <vs-button style="min-width: 22rem; display: flex; align-items: center;" class="mt-2" onClick="javascript:window.open('https://brewmoodakademi.com/', '_blank');">
    <div style="display: flex;">
      <img style="object-fit: contain" width="50px" height="30px" src="/img/brew.png">
      <span style="flex-grow: 1; text-align: center; margin-left: 1rem;">Akademi</span>
    </div>


  </vs-button>
</div>
<div>
  <vs-button style="min-width: 22rem; display: flex; align-items: center;" class="mt-2" onClick="javascript:window.open('https://mail.brewmood.com.tr/roundcube/?_task=mail&_mbox=INBOX', '_blank');">
    <div style="display: flex;">
      <img style="object-fit: contain" width="50px" height="30px" src="/img/mail.png">
      <span style="flex-grow: 1; text-align: center; margin-left: 1rem;">Email</span>
    </div>


  </vs-button>
</div>
</div>
    </vs-col>
  </div>
</template>

<script>
/*<vs-row vs-type="flex" vs-w="12" class="mt-auto">
          <img :src="footer" class="responsive" style="height:167px;" />
        </vs-row>*/
import LoginJwt from "./LoginJWT.vue";
import LoginMobil from "./LoginMobil";
import companyInfo from "../../../model/constants/companyInfo";
export default {
  components: {
    LoginJwt,
    LoginMobil,
  },
  data() {
    return {
      windowWidth: 0,
      logo: companyInfo.logo,
    };
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
};
</script>

<style lang="scss">
.vx-card {
  background: none !important;
}

.login-tabs-container {
  .con-tab {
    padding-bottom: 14px;
  }

  .con-slot-tabs {
    margin-top: 1rem;
  }
}

.login-bg {
  height: 85vh;
  width: 100%;
  border-radius: 1rem;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.4);
  filter: contrast(115%);
}

.logo {
   margin-top: 3rem;
  width: 15rem;
}
</style>
<style scoped>
@media (min-width: 769px) {
  .top-right-button {
  position: absolute;
  top: 10px;
  right: 10px;
}
}
@media (min-width: 769px) {
  .top-left-button {
    position: absolute;
    top: 10px;
    left: 10px;
  }
}

.d-none {
  display: none !important;
}

.d-md-block {
  @media (min-width: 769px) {
    display: block !important;
  }
}
</style>